module.exports = __webpack_public_path__ + "img/skills_graphic_ES_AR.7355ad73.png";